import styledComp from 'styled-components';
import { Styling } from '../../../../constants';

export const Container = styledComp.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 0 0 ${Styling.DEFAULT_SPACING_HALVED}px;
`;
